import { render } from "./403.vue?vue&type=template&id=7ffaa682"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"
script.render = render

export default script